module.exports = __webpack_public_path__ + "img/tiktok.db069755.png";